import type { EAPFeature } from '.';

export const features: EAPFeature[] = [
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
        hideIfDisabled: true,
    },
    {
        id: 'glossary',
        name: 'Glossary',
        description: 'Help employees understand your company-specific terms, abbreviations, etc.',
        descriptionLong: (
            <p>
                Define company-specific terms, values, or culture words in the company settings. Whenever a keyword
                appears in user-written text across the app, it will be highlighted and show its explanation. This way,
                your employees can look up terminology while they’re in the flow and don’t have to leave SI to look up
                terms elsewhere.
            </p>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_glossary',
        imgSrc: require('./images/glossary.jpg'),
        hideIfDisabled: false,
    },
];
